import React from 'react';

interface PageHeaderProps {
  title: string;
  lastUpdated: string;
}

export function PageHeader({ title, lastUpdated }: PageHeaderProps) {
  return (
    <div className="mb-12">
      <h1 className="text-4xl font-bold mb-4">{title}</h1>
      <p className="text-gray-600">Last Updated: {lastUpdated}</p>
      <div className="mt-8">
        <p className="text-lg">
          Welcome to Convertology.ai ("Company," "we," "us," or "our"). By accessing and using our website
          at https://convertology.ai (the "Site"), you agree to these legally binding terms and conditions
          (the "Terms") that govern your use of our Services.
        </p>
      </div>
    </div>
  );
}